import { render, staticRenderFns } from "./ActVersionCreateWithoutIdtf.vue?vue&type=template&id=44709e5c&"
import script from "./ActVersionCreateWithoutIdtf.vue?vue&type=script&lang=js&"
export * from "./ActVersionCreateWithoutIdtf.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports